import { Image } from "@components/Image";
import { Stack } from "@components/Stack";
import { Tooltip, TooltipContent, TooltipTrigger } from "@components/Tooltip";
import { Typography } from "@components/Typography";

import { TGetPrivateRequestResponse } from "@api/privateRequests";

import { ICON_PATHS } from "@configs/icons";

export const UserPrivateRequestNickname = ({ user }: { user: TGetPrivateRequestResponse }) => {
	const hasRemark = Boolean(user?.remark);

	return (
		<Stack direction="row" spacing={4} align="center" justify="center">
			{user?.isWhale ? <Image width={14} height={14} src={ICON_PATHS.WHALE} alt="whale" /> : null}
			{user?.isParticipantPromo ? <Image width={14} src={ICON_PATHS.PROMO} alt="promo" /> : null}
			<Tooltip>
				<TooltipTrigger>
					<Typography type="span" padding="none" style={{ color: user?.tipperColor ?? undefined }}>
						{user?.userNickname}
					</Typography>
				</TooltipTrigger>
				<TooltipContent sideOffset={5} side="top" zIndexMax>
					<Typography padding="none" size="sm">
						{user?.tipperCategoryDescription}
					</Typography>
				</TooltipContent>
			</Tooltip>

			{hasRemark ? (
				<span className="relative">
					<Tooltip>
						<TooltipTrigger>
							<Image width={12} height={12} src={ICON_PATHS.REMARK} alt="remark" />
						</TooltipTrigger>
						<TooltipContent sideOffset={5} side="top" zIndexMax>
							<Typography padding="none" size="sm">
								{user?.remark}
							</Typography>
						</TooltipContent>
					</Tooltip>
				</span>
			) : (
				<span className="mr-5 h-2.5 w-5" />
			)}
		</Stack>
	);
};
